var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5399 0.0866699H1.45988C0.928878 0.0866699 0.499878 0.51567 0.499878 1.04667V23.1267C0.499878 23.6577 0.928878 24.0867 1.45988 24.0867H23.5399C24.0709 24.0867 24.4999 23.6577 24.4999 23.1267V1.04667C24.4999 0.51567 24.0709 0.0866699 23.5399 0.0866699ZM22.5799 22.1667H17.0569V14.7927H20.1769L20.6449 11.1717H17.0569V8.85867C17.0569 7.80867 17.3479 7.09467 18.8509 7.09467H20.7679V3.85467C20.4349 3.80967 19.2979 3.71067 17.9719 3.71067C15.2059 3.71067 13.3129 5.39967 13.3129 8.49867V11.1687H10.1869V14.7897H13.3159V22.1667H2.41988V2.00667H22.5799V22.1667Z",
    fill: "#8A91A8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/FB.aa88c7b435f80768c40d7b28def0fefb.svg";
export { ForwardRef as ReactComponent };